module.exports = __webpack_public_path__ + "img/BG_HM_02.69247198.png";